import { useState } from "react";
import { connect } from "react-redux";
import "../../assets/css/sidebar.css";
import { useCookie } from "../../utils";
import "../../assets/scss/job.css";
import { DropDownComponent } from "./DropDownComponent";

const Sidebar = (props) => {
  const branch_id = useCookie("branch_id");

  const [activeTab, setActiveTab] = useState("");
  const [submenuOpen, setSubmenuOpen] = useState({
    employee: false,
    payroll: false,
    payrollLevelOne: false,
    bonus: false,
    jobs: false,
    reports: false,
    settings: false,
    allowance: false,
    benefit: false,
    settingsReports: false,
    allowanceIndex: null,
    benefitIndex: null,
    bonusIndex: null,
    deductionIndex: null,
    allowanceSmall: false,
    benefitSmall: false,
    bonusSmall: false,
    deductionSmall: false,
  });

  const scrollParent = {
    height: "100%",
    paddingBottom: "70px",
    overflow: "hidden",
    width: "14.688rem",
  };
  const scrollChild = {
    width: "100%",
    height: "100%",
    overflow: "auto",
    boxSizing: "content-box",
  };

  const staticDeduction = [
    { slug: "paye-tax", name: "Paye Tax" },
    { slug: "pension", name: "Employee Pension Contribution" },
    { slug: "company-pension", name: "Employer Pension Contribution" },
    { slug: "nsitf", name: "NSITF" },
  ];

  const excludedDeductionNames = [
    "paye tax",
    "pension",
    "nsitf",
    "company pension",
  ];

  return (
    <div className="sidebar sidebar-update" id="sidebar" style={scrollParent}>
      <div className="sidebar-inner" style={scrollChild}>
        <div
          id="sidebar-menu"
          className="sidebar-menu"
          style={{ width: "100%" }}
        >
          <ul style={{ width: "14.688rem;" }}>
            <DropDownComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              submenuOpen={submenuOpen}
              setSubmenuOpen={setSubmenuOpen}
              props={props}
              branch_id={branch_id}
              staticDeduction={staticDeduction}
              excludedDeductionNames={excludedDeductionNames}
            />
          </ul>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    // User: state.api.User,
    deductionSettings: state.deductionSettings.deductions,
    bonusSettings: state.bonusSettings.bonus,
    allowance: state.allowanceReducer.allowances,
    benefit: state.BenefitReducer.benefits,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
